export default __webpack_public_path__ + "static/elf-example-3-eacce289dd49c09b2152be399ae8c6d1.png";